import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

const signOut = async (): Promise<void> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  await PrivateAdminPanelInstance.post(API_ROUTES.SIGN_OUT, {
    request_token: token?.AccessToken,
  });
};

export const useSignOut = () =>
  useMutation<void, Error>({
    mutationKey: ["signOut"],
    mutationFn: signOut,
  });
